<form id="categoryCardForm">
    <div class="content" style="text-align: center;">
        <button class="nowrap btn btn-primary btn-xs active" *ngIf="selectedCategoryID === '0'" (click)="getCategoryPolicies('0')" disabled>SCHOOL BOARD POLICIES</button>
        <button class="nowrap btn btn-primary btn-xs" *ngIf="selectedCategoryID !== '0'" (click)="getCategoryPolicies('0')">SCHOOL BOARD POLICIES</button>
    </div>
    <div class="content" style="text-align: center;">
        <div class="item" *ngFor="let category of categoryList">
            <button class="wrap btn btn-primary btn-xs active" *ngIf="category.description.length > 10 && selectedCategoryID===category.categoryID" (click)="getCategoryPolicies(category.categoryID)" disabled>{{category.description}}</button>
            <button class="nowrap btn btn-primary btn-xs active" *ngIf="category.description.length < 10 && selectedCategoryID===category.categoryID" (click)="getCategoryPolicies(category.categoryID)" disabled>{{category.description}}</button>

            <button class="wrap btn btn-primary btn-xs" *ngIf="category.description.length > 10 && selectedCategoryID!==category.categoryID" (click)="getCategoryPolicies(category.categoryID)">{{category.description}}</button>
            <button class="nowrap btn btn-primary btn-xs" *ngIf="category.description.length < 10 && selectedCategoryID!==category.categoryID" (click)="getCategoryPolicies(category.categoryID)">{{category.description}}</button>
        </div>
        <div class="item">
            <button class="nowrap btn btn-primary btn-xs" style="background-color: rgb(151, 150, 150);" *ngIf="offlineClicked">OFFLINE POLICIES</button>
            <button class="nowrap btn btn-primary btn-xs active" style="background-color: #b3b4b5;" *ngIf="!offlineClicked" (click)="getCategoryPolicies_Offline('0')">OFFLINE POLICIES</button>
        </div>
    </div>
</form>
<form id="updatePolicyListForm">
    <div class="content" style="text-align: center;">
        <div class="col-sm-12" style="font-size: 12px">
            <mat-form-field appearance="standard">
                <mat-label>Filter by title or policy Number</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Title or Policy Number" #input>
            </mat-form-field>
        </div>
    </div>
    <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="datasource" matSort>
            <ng-container matColumnDef="category">
                <mat-header-cell *matHeaderCellDef mat-sort-header [style.background-color]="color">Category</mat-header-cell>
                <mat-cell class="category-cell" *matCellDef="let policy">
                    <span class="mobile-label">Category: </span>
                    {{policy.category}}
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef mat-sort-header [style.background-color]="color">Title</mat-header-cell>
                <mat-cell class="title-cell" *matCellDef="let policy">
                    <span class="mobile-label">Title: </span>
                    {{policy.title}}
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="policyNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header [style.background-color]="color">Policy Number</mat-header-cell>
                <mat-cell class="policyNumber-cell" *matCellDef="let policy">
                    <span class="mobile-label">Policy Number: </span>
                    <!-- <a href="policypdfviwer/{{policy.fileName}}" target="_blank" (click)="window.open('https://locahost:4200/policypdfviwer/' + policy.fileName, 'name','width=600,height=400')">{{policy.fileName}}</a> -->
                    <!-- <a mat-button [routerLink]="['policypdfviwer', policy.fileName]" target="_blank">{{policy.fileName}}</a> -->
                    <a href="https://schoolinfo.browardschools.com/bcpsweb/displaypdf.html?filename={{policy.fileName}}" target="_blank">
                        {{policy.policyNumber}}
                    </a>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="policyNumberFormer">
                <mat-header-cell *matHeaderCellDef mat-sort-header [style.background-color]="color">Former Policy Number</mat-header-cell>
                <mat-cell class="policyNumberFormer-cell" *matCellDef="let policy">
                    <span class="mobile-label">Former Policy Number: </span>
                    {{policy.policyNumberFormer}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="color:darkgray; font: bold;"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</form>